<template>
  <div>
    <Navbar/>
    
    <section class="fct-hero-im" id="old-carousel">
      <div class="hero-bg-wrap">
        <img src="@/assets/banner/background.png" alt="" class="hero-bg-img">
        <div class="hero-mask"></div>
      </div>
      <div class="container">
        <div class="content-block">
          <h1 class="hero-title">Your Trusted Manufacturing<br> Partner - XCL</h1>
          <div class="desc">
            <p>XCL offers cost-effective custom product prototyping and low-volume manufacturing services at a rapid speed.</p>
          </div>
          <ul class="feature-list">
            <li class="feature-item">
              <span class="check-icon">✓</span>
              Quick Response in a Few Hours
            </li>
            <li class="feature-item">
              <span class="check-icon">✓</span>
              Rapidly-made Prototypes in a Few Days
            </li>
            <li class="feature-item">
              <span class="check-icon">✓</span>
              High-Precision Capabilities
            </li>
            <li class="feature-item">
              <span class="check-icon">✓</span>
              Flexible for Low-volume manufacturing
            </li>
          </ul>
          <div class="btn-group">
            <span class="btn btn-cnc-quote" @click="$router.push('/quote')">Get Instant Quote</span>
            <p class="text-small">All uploads files are safe and confidential</p>
          </div>
        </div>
      </div>
    </section>

    <div class="about-us-wrapper">
      <div class="about-us-container">
        <div class="hero-section">
          <div class="hero-content">
            <div class="text-column">
              <h1 class="section-title">About Us</h1>
              <p class="description">
                Welcome to XCL Manufacturing. Since 2009, our facility has been dedicated to delivering high-quality, efficient, and cost-effective production solutions to businesses worldwide. As a direct manufacturer, we cut out the middleman to save you time and money.<br><br>
                Our state-of-the-art factory is fully equipped for CNC machining, sheet metal fabrication, and 3D printing. We proudly manufacture precision parts for demanding industries like aerospace, automotive, medical, and consumer products. With stringent in-house quality control and advanced machinery on our shop floor, we ensure precise, reliable results on every project.<br><br>
                From rapid prototyping to high-volume mass production, our production lines are built for flexibility and scale. We pride ourselves on a highly efficient, streamlined production process. Our international business team ensures your exact specifications are accurately processed and directly executed on our factory floor. We maintain strict quality standards from your initial files to the final product.<br><br>
                At XCL, we turn your blueprints into reality right here on our shop floor—with unmatched speed, precision, and direct-to-customer value.<br><br>
                Experience direct manufacturing at its best. Let’s build it together.
              </p>
              <button class="cta-button" @click="$router.push('/quote')">TELL US YOUR PROJECT</button>
            </div>

            <div class="image-column">
              <div class="image-wrapper">
                <div class="blue-backdrop"></div>
                <img src="@/assets/images/about_us/1.png" alt="XCL Building" class="company-image" />
              </div>
            </div>
          </div>
        </div>

        <div class="cards-section">
          <div class="card" v-for="(card, index) in companyValues" :key="index">
            <h3 class="card-title">{{ card.title }}</h3>
            <p class="card-text">{{ card.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="certifications-section">
      <h2 class="section-title">Certifications</h2>
      <div class="cert-container">
        <div class="cert-item" v-for="(cert, index) in certificates" :key="index">
          <div class="image-wrapper">
            <img :src="cert.image" :alt="cert.name" class="cert-image" />
          </div>
          <p class="cert-name">{{ cert.name }}</p>
        </div>
      </div>
    </div>

    <WhyChoose/>
    <HowWeWork/>
    <reviews/>
    <quote/>
    <Footer/>
  </div>
</template>

<script>
import Footer from './components/Footer.vue';
import Navbar from './components/Nav.vue';
import WhyChoose from './components/Whychoose.vue';
import HowWeWork from './components/HowWeWork.vue';
import reviews from './components/reviews.vue';
import quote from './components/quote.vue';

export default {
  name: 'About',
  components: {
    Navbar,
    Footer,
    WhyChoose,
    HowWeWork,
    reviews,
    quote
  },
  data() {
    return {
      // 底部卡片的数据，方便后续维护和修改
      companyValues: [
        {
          title: 'Our Vision',
          description: 'The best on-demand manufacturing service provider for everyone to quickly prototype, manufacture, and iterate their products.'
        },
        {
          title: 'Our Mission',
          description: 'We strive to be the most trusted and reliable rapid prototyping and manufacturing service provider for our global customers.'
        },
        {
          title: 'Core Values',
          description: 'By offering one-stop rapid prototyping, tooling and low volume manufacturing services to help companies bring their product ideas to market faster!'
        }
      ],
      // 证书数据列表，方便统一管理和后续增删
      certificates: [
        {
          name: 'ISO9001-2015',
          image: require('@/assets/certificate/ISO9001-2015.jpg')
        },
        {
          name: 'ISO13485-2016',
          image: require('@/assets/certificate/ISO13485-2016.jpg')
        },
        {
          name: 'ISO14001-2015',
          image: require('@/assets/certificate/ISO14001-2015.jpg')
        },
        {
          name: 'IATF 16949-2016',
          image: require('@/assets/certificate/IATF-16949-2016.jpg')
        }
      ]
    };
  }
}
</script>

<style scoped>
/* =========================================
   1. Hero Banner 区域样式
========================================= */
.fct-hero-im {
  position: relative;
  width: 100%;
  min-height: 525px;
  padding: 60px 0;
  overflow: hidden;
  background: #ffffff;
  margin-top: -60px;
}

.hero-bg-wrap {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.fct-hero-im .container {
  padding: 0 608px 0 0; 
  max-width: 1200px;
  margin: 0 auto;
  position: relative; 
  z-index: 10;      
}

.content-block {
  width: 80%;
  margin: 0 auto;
  text-align: left;
}

.hero-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0.9;
  display: block;
}

.hero-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0.95) 40%, rgba(255, 255, 255, 0) 80%);
  z-index: 2;
}

.hero-title {
  font-size: 42px;
  font-weight: 600;
  color: #333333;
  line-height: 1.15;
  margin-bottom: 1.5rem;
  font-family: inherit;
  white-space: nowrap; 
  overflow: visible;
}

.desc p {
  font-size: 1rem;
  color: #555555;
  line-height: 1.7;
  margin-bottom: 12px;
  font-family: inherit;
  font-weight: 500;
}

.feature-list {
  list-style: none;
  margin: 0 0 30px 0;
  padding: 0;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  color: #505050;
  margin-bottom: 4px;
  line-height: 24px; 
  font-weight: 500;
}

.check-icon {
  color: #16bc9c;
  font-weight: bold;
  margin-right: 12px;
  font-size: 20px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.btn-group {
  margin: 30px 0;
}

.btn-cnc-quote {
  display: inline-block;
  background-color: #16bc9c;
  color: #ffffff;
  font-size: 1rem;
  padding: 14px 29px;
  border-radius: 4px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: color 0.4s;
}

.btn-cnc-quote::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: #027062;
  transition: all 0.4s;
  z-index: -1;
}

.btn-cnc-quote:hover::before {
  left: 0;
}

.text-small {
  font-size: 0.75rem;
  color: #17202a;
  margin-top: -3px;
  font-weight: 600;
}

/* =========================================
   2. About Us 区域样式
========================================= */
.about-us-wrapper {
  background-color: #f8f9fa;
  padding: 80px 20px;
  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  color: #333;
}

.about-us-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.hero-section {
  margin-bottom: 60px;
}

.hero-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
}

.text-column {
  flex: 1;
  max-width: 600px;
}

.section-title {
  font-size: 36px;
  font-weight: normal;
  color: #2c3e50;
  margin-top: 0;
  margin-bottom: 30px;
}

.description {
  font-size: 16px;
  line-height: 1.8;
  color: #555;
  margin-bottom: 40px;
}

.highlight-link {
  color: #0066cc;
  text-decoration: none;
}

.highlight-link:hover {
  text-decoration: underline;
}

.cta-button {
  background-color: #16bc9c;
  color: #ffffff;
  border: none;
  padding: 14px 28px;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.cta-button:hover {
  background-color: #0e957b;
}

.image-column {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.image-wrapper {
  position: relative;
  width: 100%;
  max-width: 550px;
  padding-top: 20px;
  padding-right: 20px; 
}

.blue-backdrop {
  position: absolute;
  top: 0;
  right: 0;
  width: 90%;
  height: 90%;
  background-color: #16bc9c;
  z-index: 1;
}

.company-image {
  position: relative;
  z-index: 2;
  width: 100%;
  height: auto;
  display: block;
  transform: translate(-5px, 5px); 
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.cards-section {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  margin-top: 40px;
}

.card {
  flex: 1;
  background-color: #ffffff;
  padding: 40px 30px;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.04);
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.08);
}

.card-title {
  font-size: 22px;
  font-weight: normal;
  color: #333;
  margin-top: 0;
  margin-bottom: 20px;
}

.card-text {
  font-size: 15px;
  line-height: 1.6;
  color: #666;
  margin: 0;
}

/* =========================================
   3. 证书区域样式
========================================= */
.certifications-section {
  background-color: #f8f9fa;
  padding: 80px 20px;
  text-align: center;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.cert-container {
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.cert-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 260px;
}

.cert-item .image-wrapper {
  width: 100%;
  background-color: #fff;
  padding: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border: 1px solid #eaeaea;
  margin-bottom: 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.cert-item .image-wrapper:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.12);
}

.cert-image {
  width: 100%;
  height: auto;
  display: block;
}

.cert-name {
  font-size: 16px;
  color: #555;
  margin: 0;
}


/* =========================================
   4. 响应式布局 (Media Queries 整合)
========================================= */

/* 平板屏幕 (max-width: 1024px，原为992px) */
@media (max-width: 1024px) {
  /* Hero Banner 自适应 */
  .fct-hero-im .container {
    padding: 0 40px; 
  }
  .content-block {
    width: 100%; 
  }
  .hero-title {
    white-space: normal; 
  }
  .hero-mask {
    background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0.95) 60%, rgba(255, 255, 255, 0) 100%);
  }

  /* About Us 区域自适应 */
  .hero-content {
    flex-direction: column;
    gap: 40px; 
  }
  .text-column {
    max-width: 100%;
  }
  .image-column {
    width: 100%;
    justify-content: center;
  }
  .image-wrapper {
    max-width: 100%;
    padding-right: 10px; 
    padding-top: 10px;
  }
  .company-image {
    transform: translate(-10px, 10px); 
  }
  .blue-backdrop {
    width: 95%;
    height: 95%;
  }
  .cards-section {
    flex-direction: column;
    gap: 20px;
  }

  /* 证书区域自适应 */
  .cert-container {
    gap: 20px;
  }
  .cert-item {
    max-width: calc(50% - 20px); 
  }
}

/* 专门针对 大于768px, 小于等于1024px 时按钮居中 */
@media (min-width: 769px) and (max-width: 1024px) {
  .cta-button {
    display: block;
    margin: 0 auto;
  }
}

/* 小号平板/部分手机横屏 (max-width: 768px) */
@media (max-width: 768px) {
  .fct-hero-im {
    padding: 100px 0 60px;
  }
  .fct-hero-im .container {
    padding: 0 20px;
  }
}

/* 手机屏幕 (max-width: 576px) */
@media (max-width: 576px) {
  /* About Us 区域手机自适应 */
  .about-us-wrapper {
    padding: 50px 15px; 
  }
  .section-title {
    font-size: 28px;
    margin-bottom: 20px;
  }
  .description {
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 30px;
  }
  .cta-button {
    width: 100%;
    padding: 14px 0;
  }
  .card {
    padding: 30px 20px;
  }

  /* 证书区域手机自适应 */
  .cert-item {
    max-width: 90%; 
  }
}
</style>